import { createApiActionType } from 'app/store/utils';

const apiType = createApiActionType('snowflake');

export const LIST_SNOWFLAKE_WAREHOUSES = apiType('ListSnowflakeWarehouses');
export const LIST_USER_SESSION_WAREHOUSES = apiType('ListUserSessionWarehouses');
export const SET_USER_SESSION_WAREHOUSE = apiType('SetUserSessionWarehouse');
export const LIST_SNOWFLAKE_ROLES = apiType('ListSnowflakeRoles');

export const GET_DATAMEER_SNOWFLAKE_WAREHOUSE = apiType('GetDatameerSnowflakeWarehouse');

export const SET_DATAMEER_SNOWFLAKE_WAREHOUSE = apiType('SetDatameerSnowflakeWarehouse');

export const SET_SNOWFLAKE_ROLE = apiType('SetSnowflakeRole');

export const GET_SNOWFLAKE_DATABASES = apiType('GetSnowflakeDatabases');
export const GET_SNOWFLAKE_SOURCES = apiType('GetSnowflakeSources');
export const GET_SNOWFLAKE_SCHEMAS = apiType('GetSnowflakeSchemas');
export const GET_SNOWFLAKE_SOURCE_COLUMNS = apiType('GetSnowflakeSourceColumns');
export const SEARCH_SNOWFLAKE_OBJECTS = apiType('SearchSnowflakeObjects');
export const SEARCH_SNOWFLAKE_DESTINATIONS = apiType('SearchSnowflakeDestinations');

export const DELETE_SNOWFLAKE_TABLE = apiType('DeleteSnowflakeTable');
